module.exports = __webpack_public_path__ + "static/media/en-data-roaming-other_6.a8638e98.png";